/* eslint-disable camelcase */
/* eslint-disable new-cap */
import { Images } from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import Tweener from '../../library/Tweener';

export default class City extends Phaser.GameObjects.Container {
  constructor(game) {
    super(game, game.scale.width * .5, game.scale.height + 500);
    this.game = game;

    this.cityBackground = Images.addImage(0, 0, 'cityBackground', this);
    this.cityBackground.setOrigin(.5);

    this.largeLight = Images.addImage(0, 15, 'largeLight', this);
    this.largeLight.setOrigin(.5);
    this.fadeLargeLight_Out();
    this.add(this.largeLight);

    this.city = Images.addImage(0, 35, 'city', this);
    this.city.setOrigin(.5);
    this.add(this.city);

    this.cityY = this.game.scale.height - 130;

    this.smallLights = [];
    this.addSmallLight(-10, -110, 1);
    this.addSmallLight(128, -109, .5);
    this.addSmallLight(152, 5, .8);
    this.addSmallLight(39, 77, 1.2);
    this.addSmallLight(59, -53, .5);
    this.addSmallLight(96, -77, .5);
    this.addSmallLight(179, -9, .3);
    this.addSmallLight(191, 21, .3);
    this.addSmallLight(-27, 58, .5);
    this.addSmallLight(-128, -92, .8);
    this.addSmallLight(-74, -49, .5);
    this.addSmallLight(-189, -9, .3);
    this.addSmallLight(-207, 21, .3);
    this.addSmallLight(-171, 53, 1);
  }

  Display() {
    Tweener.To(this, { y: this.cityY }, 2000, Phaser.Math.Easing.Circular.Out);
  }

  Destroy() {
    this.game.cameras.main.shake(0.004, 800);

    Tweener.Kill(this.largeLight);
    Tweener.To(this.largeLight, { alpha: 1 }, 400);
    Tweener.To(this.largeLight, { scale: 1 }, 400);
    Tweener.TweenTint(this.largeLight, 0xfbff8a, 400);

    for (let i = 0; i < this.smallLights.length; i++) {
      Tweener.Kill(this.smallLights[i]);
      Tweener.To(this.smallLights[i], { alpha: 1 }, 400);
      Tweener.TweenTint(this.smallLights[i], 0xfbff8a, 400);
    }

    const timer = this.game.time.addEvent({ delay: 200, callback: () => {this.eh_FadeCityOut(); } });
    timer.paused = false;
    timer.loop = false;
  }

  eh_FadeCityOut() {
    Tweener.To(this.largeLight, { alpha: 0 }, 400);
    Tweener.To(this.largeLight, { scale: 0 }, 400);

    for (let i = 0; i < this.smallLights.length; i++) {
      Tweener.To(this.smallLights[i], { alpha: 0 }, 400);
    }

    Tweener.To(this, { y: this.game.scale.height + 500 }, 3000, Phaser.Math.Easing.Circular.InOut);
  }

  fadeLargeLight_In() {
    Tweener.To(this.largeLight, { alpha: 1 }, 3000, Phaser.Math.Easing.None).on('complete', () => {this.fadeLargeLight_Out();});
    Tweener.To(this.largeLight, { scale: 1 }, 5000, Phaser.Math.Easing.None);
  }

  fadeLargeLight_Out() {
    Tweener.To(this.largeLight, { alpha: .7 }, 3000, Phaser.Math.Easing.None).on('complete', () => {this.fadeLargeLight_In();});
    Tweener.To(this.largeLight, { scale: .8 }, 5000, Phaser.Math.Easing.None);
  }

  addSmallLight(x, y, scale) {
    const delay = this.getRandDuration(true);

    const smallLight = Images.addImage(x + .6, y + 35, 'smallLight', this);
    smallLight.setOrigin(.5);
    smallLight.setScale(scale);
    this.smallLights.push(smallLight);

    this.add(smallLight);
    this.game.time.addEvent({ delay, callback: () => {this.fadeSmallLight_Out(smallLight);} });
  }

  fadeSmallLight_In(light) {
    const duration = this.getRandDuration(true);
    Tweener.To(light, { alpha: 1 }, duration, Phaser.Math.Easing.None).on('complete', () => {this.fadeSmallLight_Out(light);});
    Tweener.TweenTint(light, 0xe1fc42, duration);
  }

  fadeSmallLight_Out(light) {
    const duration = this.getRandDuration(false);
    Tweener.To(light, { alpha: .5 }, duration, Phaser.Math.Easing.None).on('complete', () => {this.fadeSmallLight_In(light);});
    Tweener.TweenTint(light, 0x9eb12c, duration);
  }

  getRandDuration(isFadingIn) {
    return isFadingIn ? (Math.random() * 2000) + 2000 : (Math.random() * 500) + 2000;
  }
}